class MainProductSelector extends ProductSelector {
  // Color name mappings for special characters
  // static COLOR_MAPPINGS = {
  //   'Weiß': 'Weiss',
  //   'Grün': 'Grun',
  //   'Türkis': 'Turkis'
  // };

  constructor() {
    super();

    this.productMedia = document.querySelector('product-media');
    this.productMediaSlider = this.productMedia.querySelector('[data-slider]');
  }

  /**
   * Connected callback - override to handle initial color filtering
   */
  connectedCallback() {
    super.connectedCallback();

    // Wait for product-media to be initialized, then filter by initial color
    if (!this.productMediaSlider) {
      return;
    }

    this.initializeColorFilter();
  }

  /**
   * Initialize color filter on page load
   */
  initializeColorFilter() {
    // Check if slider is ready, or wait for ready event
    const applyInitialFilter = () => {
      if (!this.productMedia.isReady()) {
        // Wait for ready event or check again
        this.productMedia.addEventListener('product-media-ready', applyInitialFilter, { once: true });
        setTimeout(() => {
          if (this.productMedia.isReady()) {
            applyInitialFilter();
          }
        }, 100);
        return;
      }

      // Find the initially selected color swatch
      const selectedColorInput = this.querySelector('input[data-type="color"]:checked');
      if (selectedColorInput && selectedColorInput.value) {
        // Filter by the initially selected color
        this.filterMediaByColor(selectedColorInput.value);
        // After filtering, ensure we're showing the correct variant image
        this.productMedia.addEventListener('product-media-ready', () => {
          this.updateMedia();
        }, { once: true });
      } else {
        // Even if no color filter, ensure variant image is shown
        this.updateMedia();
      }
    };

    // Try immediately first
    if (!this.productMediaSlider) {
      return;
    }

    if (this.productMedia.isReady()) {
      applyInitialFilter();
    } else {
      // Wait for ready event
      this.productMedia.addEventListener('product-media-ready', applyInitialFilter, { once: true });
      // Fallback timeout in case event doesn't fire
      setTimeout(applyInitialFilter, 500);
    }
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);

    this.updateURL();

    if (event.target.dataset.type === 'color') {
      this.filterMediaByColor(event.target.value);
    }

    if (event.target.type === 'number' || !this.currentVariant) {
      return;
    }

    // Filter media by color if a color swatch was selected
    if (!this.productMediaSlider) {
      return;
    }

    if (event.target.dataset.type != 'color') {
      this.updateMedia();
    }
  }

  /**
   * Filter media by selected color swatch
   *
   * @param {String} colorValue - The color value from the swatch
   * @returns {Void}
   */
  filterMediaByColor(colorValue) {
    if (!this.productMedia || !colorValue) {
      return;
    }

    // Normalize color name using mapping if needed
    // colorValue = MainProductSelector.COLOR_MAPPINGS[colorValue] || colorValue;

    this.productMedia.filterMediaByColor(colorValue);
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    this.productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
